<!-- Vue component of a channel with icon.
Props : value, name and type  -->
<template>
  <span class="ChannelIcon d-inline-block text-center">
    <i class="fa fa-phone fa-lg" v-if="type === 'phone'"></i>
    <i class="fa fa-mobile fa-lg" v-if="type === 'mobile'"></i>
    <i class="fa fa-envelope" v-if="type === 'email'"></i>
  </span>
</template>

<script>
export default {
  name: "ChannelIcon",
  props: {
    "type": {
      type: String,
      required: true,
      validator: val => ['phone', 'mobile', 'email'].includes(val),
    },
  }
}
</script>

<style lang="scss" scoped>
.ChannelIcon {
  min-width: 1em;
}
</style>
